module.exports = __webpack_public_path__ + "static/media/law_in_hand_1.4520f344.jpg";